import { NgModule } from '@angular/core';

import { CoreModule }              from '../core/core.module';
import { ImportComponent }         from './import.component';
import { ImportEquationComponent } from './import.equation.component';
import { ImportHubComponent }      from './import.hub.component';
import { ImportProgressComponent } from './import.progress.component';
import { ImportSummaryComponent }  from './import.summary.component';
import { ImportsService }          from './imports.service';
import { SharedModule }            from '../shared/shared.module';

@NgModule({
  declarations: [
    ImportComponent,
    ImportEquationComponent,
    ImportHubComponent,
    ImportProgressComponent,
    ImportSummaryComponent
  ],
  entryComponents: [
    // ImportHubComponent is created by AngularJS through the downgrade directive rather
    // than by an Angular template, which is what entryComponents is for.
    ImportHubComponent,
    ImportProgressComponent
  ],
  exports: [
    ImportComponent,
    ImportEquationComponent,
    ImportHubComponent,
    ImportSummaryComponent
  ],
  imports: [
    CoreModule,
    SharedModule
  ],
  providers: [
    ImportsService
  ]
})
export class ImportsModule {}
